import React, { useState } from 'react'
import cx from '../Utils/cx'
import SummaryTab from '../Studio/SummaryTab'
import QATab from '../Studio/QATab'

import './AITab.css'

const AITab = ({ transcriptData, transcriptXMLPath, fileName, mediaId, onTimestampClick }) => {
    const [aiSubTab, setAiSubTab] = useState('summary')

    return (
        <div className={`ai-tab-content ${aiSubTab === 'summary' ? 'ai-tab-content--fixed' : ''}`}>
            <div className="ai-sub-tabs">
                <button
                    className={cx({ active: aiSubTab === 'summary' })}
                    onClick={() => setAiSubTab('summary')}
                >
                    Summarize
                </button>
                <button
                    className={cx({ active: aiSubTab === 'qa' })}
                    onClick={() => setAiSubTab('qa')}
                >
                    Q&A
                </button>
            </div>
            {aiSubTab === 'summary' && (
                <SummaryTab
                    transcriptData={transcriptData}
                    transcriptXMLPath={transcriptXMLPath}
                    fileName={fileName}
                    mediaId={mediaId}
                    onTimestampClick={onTimestampClick}
                />
            )}
            {aiSubTab === 'qa' && (
                <QATab
                    transcriptData={transcriptData}
                    transcriptXMLPath={transcriptXMLPath}
                    fileName={fileName}
                    mediaId={mediaId}
                    onTimestampClick={onTimestampClick}
                />
            )}
        </div>
    )
}

export default AITab
